// import { msalInstance, loginRequest, protectedResources } from "../config/msalConfig";
import { Discipline } from "../models/discipline";

import { ListParams } from "../models/listParams";
import { OgcParams } from "../models/geo/ogcParams";

import { BaseWebService } from "./base.web.service";
import { FeatureCollection, GeoJsonProperties, Geometry } from "geojson";

export class PlannenWebService extends BaseWebService {
    
    public async getInfraPlannen(organizationId: string, listParams: ListParams) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/api/${organizationId}/plannen${params}`;
        return this.makeRequest(url, 'GET', headers);
    }
    
    public async getInfraPlanById(organizationId: string, planId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/api/${organizationId}/plannen/${planId}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getInfraPlannenFilters(organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/api/${organizationId}/planfilters`;
        return this.makeRequest(url, 'GET', headers);
    }

    // Plannen OGC features

    public async getPlannenOgcFeaturesCollectionsSchema(organizationId: string) {
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/ogc-features/${organizationId}/collections/plans/schema`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getPlannenOgcFeaturesCollectionsItems(organizationId: string, ogcParams: OgcParams): Promise<FeatureCollection<Geometry, GeoJsonProperties>> {
        const params = this.createOgcParams(ogcParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/ogc-features/${organizationId}/collections/plans/items${params}`;
        return this.makeRequest<FeatureCollection<Geometry, GeoJsonProperties>>(url, 'GET', headers);
    }

    // Plans shared directly

    public async getOrganisatiesSharedPlans(organizationId: string, listParams: ListParams) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/api/${organizationId}/shared-plans${params}`;
        return this.makeRequest(url, 'GET', headers);
    }

    public async getSharedPlansByOrganisationId(organizationId: string, sharedOrganisatieId: string, listParams: ListParams) {
        const params = this.createListParams(listParams);
        const headers = await this.getHeadersJson();
        const url = `${this.appConfig.servicePlannenUrl}/api/${organizationId}/shared-plans/${sharedOrganisatieId}${params}`;
        return this.makeRequest(url, 'GET', headers);
    }


    // // EARLY TEMPLATE
    // public async getInfraPlannen_WoRkS(listParams: ListParams) {
    //     try {
    //         if (!msalInstance) {
    //             throw new Error('MSAL instance is not initialized.');
    //         }
        
            
    //         // Get the currently signed-in account
    //         const accounts = msalInstance.getAllAccounts();
    //         if (accounts.length === 0) throw new Error('No accounts available');
        
    //         // Acquire token silently
    //         const response = await msalInstance.acquireTokenSilent({
    //           ...loginRequest,
    //           account: accounts[0],  // The current account
    //           scopes: protectedResources.get(appConfig.portalUrl) || []
    //         });
        
    //         const accessToken = response.accessToken;
        
    //         const params = this.createListParams(listParams);
    //         // Now make the API call with the access token
    //         const apiResponse = await fetch(`${this.config.serviceInfraPlannenUrl}/${params}`, {
    //           method: 'GET',
    //           headers: {
    //             Authorization: `Bearer ${accessToken}`,
    //             'Content-Type': 'application/json'
    //           }
    //         });
        
    //         return await apiResponse.json();
    //     }
    //     catch (error) {
    //         console.error('Error fetching infra plannen:', error);
    //         throw error;
    //     }
    // }


    /* Mock data */
    public async getBeoordelingStatus(): Promise<Discipline[]> {
        return this.makeRequest(`/data/mock/beoordelingstatus/get_list.json`, 'GET', {});
    }

    public async getPlanDisciplines(): Promise<Discipline[]> {
        return this.makeRequest(`/data/mock/disciplines/get_list.json`, 'GET', {});
    }

    public async getPlanTypes(): Promise<any[]> {
        return this.makeRequest(`/data/mock/plantypes/get_list.json`, 'GET', {});
    }

    public async getPlanOrganisaties(): Promise<any[]> {
        return this.makeRequest(`/data/mock/organisaties/get_list.json`, 'GET', {});
    }

    public async getPlanStatus(): Promise<any[]> {
        return this.makeRequest(`/data/mock/planstatus/get_list.json`, 'GET', {});
    }
}